import { getStoreState, PUT_POLICY, save, setStoreState } from '@cogitate/ui-multi-utils';
import {
  applyResolvedPayrollProtectionAgesToPolicy,
  stripPayrollProtectionRiskQualifiersUiFields,
} from 'ui/utilities/commercial/payrollprotection/practitionerAge';
import NProgress from 'nprogress';
import { payrollProtectionKeys, routeKeys } from 'ui/data/commercial/payrollprotection/constants/keys';
import { commonKeys, storeKeys } from 'ui/data/constants/keys';
import { toast } from 'react-toastify';

const toggleButton = ({ coverageName, toggleButtonName, toggleValue, policyData }) => {
  const coverageToggleMapping = {
    leasedMedicalEquipmentToggle: 'equipmentLeaseReimbursement',
    medicalPracticeLoanToggle: 'medicalPracticeLoanReimbursement',
  };

  const isMedicalPracticeLoanToggle = coverageName === 'medicalPracticeLoanToggle';

  if (toggleButtonName !== 'Smoker') {
    // Handle coverage toggles
    if (policyData?.Risks?.PayrollProtectionUnit[0]?.Coverages) {
      policyData.Risks.PayrollProtectionUnit[0].Coverages.forEach((coverage) => {
        if (coverage.Name === coverageName) {
          coverage.Value = toggleValue ? 'include' : 'exclude';
          coverage.IsSelected = toggleValue;
        }
        if (coverage.Name === coverageToggleMapping[coverageName]) {
          if (toggleValue === false) {
            coverage.IsSelected = false;
            coverage.Limit = 0;
            coverage.LimitAmount = 0;
          }
        }
        if (isMedicalPracticeLoanToggle && coverage.Name === coverageToggleMapping.medicalPracticeLoanToggle) {
          coverage.Value = toggleValue ? 'include' : 'exclude';
          coverage.IsSelected = toggleValue;
        }
      });
    }
  }

  switch (toggleButtonName) {
    case 'LeasedMedical':
      // Reset selected plans when toggling off
      if (toggleValue === false) {
        if (coverageName === 'leasedMedicalEquipmentToggle') {
          policyData.Risks.PayrollProtectionUnit[0].SelectedPlan_MedEquip = '';
        }
      }
      break;
    case 'MedicalPractice':
      break;
    case 'Smoker':
      // Handle smoker toggle
      if (policyData.Risks?.PayrollProtectionUnit[0]?.PractitionerRiskAttributes) {
        policyData.Risks.PayrollProtectionUnit[0].PractitionerRiskAttributes.Smoker = toggleValue;
      }
      break;
    default:
      break;
  }
};

const selectPlan = (planName, policyData) => {
  const coveragePremiumMapping = {
    PPPremium: 'payrollAndLeaseReimbursement',
    LeasedMedEquipPremium: 'equipmentLeaseReimbursement',
  };

  const splitPlanName = planName.split('_')[0];
  const selectedPlanName = planName.split('_')[1];

  if (planName.includes('PPPremium')) {
    policyData.Risks.PayrollProtectionUnit[0].SelectedPlan_Payroll = selectedPlanName;
  } else if (planName.includes('LeasedMedEquipPremium')) {
    policyData.Risks.PayrollProtectionUnit[0].SelectedPlan_MedEquip = selectedPlanName;
  }

  const getPremiumFactor = policyData.Risks.PayrollProtectionUnit?.[0]?.PremiumFactors?.find(
    (premiumFactor) => premiumFactor.Name === planName
  );

  if (getPremiumFactor) {
    policyData.Risks.PayrollProtectionUnit[0].Coverages.forEach((coverage) => {
      if (coverage.Name === coveragePremiumMapping[splitPlanName]) {
        coverage.IsSelected = true;
        coverage.Limit = Number(getPremiumFactor.LimitAmount);
        coverage.LimitAmount = Number(getPremiumFactor.DisplayValue);
      }
    });
  }
};

export const onApplicatioRiskqualifiersSchemaChange =
  ({ payload: { model: changedModel, key: key } }) =>
  (dispatch, _getState) => {
    switch (key) {
      case payrollProtectionKeys.PractitionerIdentifierType:
        changedModel.AddAdditionalPractitioner.NPINumber = '';
        break;

      case payrollProtectionKeys.LeasedMedicalEquipmentToggle:
        toggleButton({
          coverageName: 'leasedMedicalEquipmentToggle',
          toggleButtonName: 'LeasedMedical',
          toggleValue: changedModel.Risks.PayrollProtectionUnit[0].Coverages[3].IsSelected,
          policyData: changedModel,
        });
        break;

      case payrollProtectionKeys.MedicalPracticeLoanToggle:
        toggleButton({
          coverageName: 'medicalPracticeLoanToggle',
          toggleButtonName: 'MedicalPractice',
          toggleValue: changedModel.Risks.PayrollProtectionUnit[0].Coverages[4].IsSelected,
          policyData: changedModel,
        });
        break;

      case payrollProtectionKeys.PayrollProtectionPlusLimit:
        selectPlan('PPPremium_' + changedModel.Risks.PayrollProtectionUnit[0].SelectedPlan_Payroll, changedModel);
        break;

      case payrollProtectionKeys.LeasedMedicalEquipmentLimit:
        selectPlan(
          'LeasedMedEquipPremium_' + changedModel.Risks.PayrollProtectionUnit[0].SelectedPlan_MedEquip,
          changedModel
        );
        break;

      case payrollProtectionKeys.MedicalPracticeLoanLimit:
        break;

      default:
        break;
    }

    if (key) {
      applyResolvedPayrollProtectionAgesToPolicy(changedModel);
      setStoreState(storeKeys.PolicyReducer, stripPayrollProtectionRiskQualifiersUiFields(changedModel));
    }
  };

export const onApplicationRiskqualifiersOnFormSubmit =
  ({ payload, saveAndExit }) =>
  async (dispatch, _getState) => {
    NProgress.start();
    const model = structuredClone(payload);
    let resp;

    //Delete AddAdditionalPractitioner from model
    delete model.AddAdditionalPractitioner;
    stripPayrollProtectionRiskQualifiersUiFields(model);

    const ApplicationReducer = getStoreState(storeKeys.ApplicationReducer);
    if (saveAndExit) {
      setStoreState(storeKeys.ApplicationReducer, {
        ...ApplicationReducer,
        IsSaveAndExit: true,
      });
    } else {
      setStoreState(storeKeys.ApplicationReducer, {
        ...ApplicationReducer,
        IsSaveAndExit: false,
      });
    }

    try {
      resp = await save(model, commonKeys.EmptyString, routeKeys.RiskQualifiersSubmit, commonKeys.EmptyString, 1);
    } catch (error) {
      toast.error(error);
      setStoreState(storeKeys.ApplicationReducer, {
        ...ApplicationReducer,
        IsSaveAndExit: false,
      });
      NProgress.done();
      throw new Error(error);
    }
    dispatch({ type: PUT_POLICY, payload: resp });
    NProgress.done();
    return resp;
  };

export const onConfirmQualificationModalSubmit =
  ({ payload, saveAndExit }) =>
  async (dispatch, _getState) => {
    const model = structuredClone(payload.model ?? {});
    const ApplicationReducer = getStoreState(storeKeys.ApplicationReducer);
    NProgress.start();

    stripPayrollProtectionRiskQualifiersUiFields(model);

    try {
      await save(model, commonKeys.EmptyString, routeKeys.RiskConfirmQualificationSubmit, commonKeys.EmptyString, 1);
    } catch (error) {
      toast.error(error);
      setStoreState(storeKeys.ApplicationReducer, {
        ...ApplicationReducer,
        IsSaveAndExit: false,
      });
      throw new Error(error);
    } finally {
      NProgress.done();
    }
  };

export const onApplicationRiskQualifiersLoad =
  ({ payload }) =>
  async (dispatch, _getState) => {
    const model = payload?.policyData ?? payload?.model;
    if (!model || model?.Attributes?.Lob !== 'PP') {
      return;
    }
    try {
      let synced;
      try {
        synced = structuredClone(model);
      } catch {
        synced = JSON.parse(JSON.stringify(model));
      }
      applyResolvedPayrollProtectionAgesToPolicy(synced);
      dispatch({ type: PUT_POLICY, payload: synced });
    } catch (error) {
      const message = error?.message ?? String(error);
      console.error('Risk Qualifiers: practitioner age sync failed', message, error);
    }
  };
